import axios from 'axios';
import { baseUrl } from '@/Base_url';



// Create axios instance
const axiosInstance = axios.create({
  baseURL: baseUrl,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
});


// Request interceptor → attach access token
axiosInstance.interceptors.request.use(
  (config) => {
    const userStr = localStorage.getItem('medApp_currentUser');

    if (userStr) {
      try {
        const storedData = JSON.parse(userStr);
        const accessToken = storedData?.access_token;

        if (accessToken) {
          config.headers.Authorization = `Bearer ${accessToken}`;
        }
      } catch (error) {
        console.error('Invalid user data in localStorage', error);
      }
    }

    // If the data is FormData, remove Content-Type header to let browser set it with boundary
    if (config.data instanceof FormData) {
      delete config.headers['Content-Type'];
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor → handle 401 globally
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('medApp_currentUser');
     window.location.href = '/dermat-uat/front/login';
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
